import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import Section from 'components/ui/Section'
import { Close } from 'components/ui/Close'
import useKidHook from 'components/pages/kids/Kid.use'
import KidChores from 'components/pages/kids/KidChores'
import Avatars from 'assets/avatars'

const Kids = () => {
  const { id } = useParams()
  const history = useHistory()
  const {
    data: { name, chores, avatar },
    error,
    fetching,
    updateChore,
  } = useKidHook({ id })

  const onClickClose = () => history.push('/kids')

  return !fetching && !error && name && chores ? (
    <Section>
      <div className="relative flex items-center justify-center mb-12">
        <div className="w-24 h-24 pt-2 mr-8 overflow-hidden rounded-full shadow-xs bg-gray-100">
          <img src={Avatars[avatar]} alt="Avatar" />
        </div>
        <h1 className="text-6xl font-thin text-center text-gray-700">{name}</h1>
        <Close onClick={onClickClose} className="absolute top-0 right-0 mr-4" />
      </div>
      <div className="flex items-start justify-center">
        <div className="flex flex-wrap w-1/2">
          <KidChores chores={chores} updateChore={updateChore} />
        </div>
      </div>
    </Section>
  ) : null
}

export default Kids
